import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from '@ngx-translate/core';
import { DataTablesModule } from "angular-datatables";
import { FooterComponent } from "app/admin/layout/footer/footer.component";
import { AlertModule } from "ngx-bootstrap/alert";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ModalModule } from "ngx-bootstrap/modal";
import { PopoverModule } from "ngx-bootstrap/popover";
import { TabsModule } from "ngx-bootstrap/tabs";
import { CookieService } from 'ngx-cookie-service';
import { NgxUploaderModule } from 'ngx-uploader';
import { LoginService } from '../../shared/pages/login/login.service';
import { AuthGuard } from '../../shared/services/authguard.service';
import { PCodeServices } from '../../shared/services/pcode.service';
import { AppBackdropComponent } from "./components/app_backdrop/app_backdrop.component";
import { SmdFabSpeedDialActionsComponent, SmdFabSpeedDialComponent, SmdFabSpeedDialTriggerComponent } from "./components/fab";
import { ResetPasswordInternalComponent } from './components/reset-password/reset-password.component';
import { TaskComponent } from './components/todo/task.component';
import { TodoComponent } from './components/todo/todo.component';
import { UploadComponent } from "./components/upload/upload.component";
import { WeatherComponent } from "./components/weather/weather.component";
import { UserSelectorComponent } from './users/users/selector/selector.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatTabsModule,
        MatStepperModule,
        MatToolbarModule,
        MatTooltipModule,
        BsDropdownModule.forRoot(),
        AlertModule.forRoot(),
        TabsModule.forRoot(),
        ModalModule.forRoot(),
        PopoverModule.forRoot(),
        TranslateModule,
        NgxUploaderModule,
        DataTablesModule
    ],
    declarations: [
        AppBackdropComponent,
        FooterComponent,
        TaskComponent,
        WeatherComponent,
        TodoComponent,
        UploadComponent,
		SmdFabSpeedDialActionsComponent,
		SmdFabSpeedDialComponent,
		SmdFabSpeedDialTriggerComponent,

        // pcode
        UserSelectorComponent,
        ResetPasswordInternalComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatRippleModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatTabsModule,
        MatStepperModule,
        MatToolbarModule,
        MatTooltipModule,
        DataTablesModule,
		SmdFabSpeedDialActionsComponent,
		SmdFabSpeedDialComponent,
		SmdFabSpeedDialTriggerComponent,
        AppBackdropComponent,
        FooterComponent,
        TaskComponent,
        WeatherComponent,
        TodoComponent,
        UploadComponent,
        ReactiveFormsModule,
        TabsModule,
        BsDropdownModule,
        AlertModule,
        ModalModule,
        PopoverModule,
        TranslateModule,
        NgxUploaderModule,

        // pcode
        UserSelectorComponent,
        ResetPasswordInternalComponent
    ],
    providers:
        [
            // custom services
            AuthGuard,
            LoginService,
            CookieService,
            PCodeServices
        ]
})
export class AdminSharedModule
{
    static forRoot(): ModuleWithProviders<AdminSharedModule>
    {
        return {
            ngModule: AdminSharedModule
        };
    }
}
